import { observer } from "mobx-react-lite";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import FontBody3 from "../../../../../../components/fonts/font-body3/font-body3";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import IconEdit from "../../../../../../components/icons/icon-edit/icon-edit";
import { ButtonIcon } from "../../../../../../components/inputs/button-icon/button-icon";
import GridLine from "../../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import GridLineButtons from "../../../../../../components/layouts/grid-line-layout/grid-line/grid-line-buttons/grid-line-buttons";
import GridLineItem from "../../../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import { useNavigate } from "react-router-dom";
import ReturnMethodStore from "../../../../stores/return-method-store";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import Translation from "../../../../../../translation/translation";
import { TOOLTIP_VARIANTS, Tooltip } from "../../../../../../components/tooltip/tooltip";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import Icon from "../../../../../../components/icons/icon/icon";
import IconTranslationIndicator from "../../../../../../components/icons/icon-translation-indicator/icon-translation-indicator";
import GridLineIndicators from "../../../../../../components/layouts/grid-line-layout/grid-line/grid-line-indicators/grid-line-indicators";
import IconDelete from "../../../../../../components/icons/icon-delete/icon-delete";

export interface ReturnMethodProps {
    returnMethod: ReturnMethodStore;
    deleteCallback: () => void;
}


const ReturnMethodLine: React.FC<ReturnMethodProps> = observer(({ returnMethod, deleteCallback }) => {

    const navigate = useNavigate();
    const { hasMissingTranslations, getTranslation } = useTranslation();

    const onReturnMethodClicked = () => navigate({
        pathname: returnMethod.id.toString()
    });

    return <GridLine
        onClick={() => onReturnMethodClicked()}
        settings={{
            columns: [{ width: 2 }, { width: 2}, {width: 2}, {width: 30, type: 'px'}, {width: 80, type: 'px'} ]
        }}
        columns={[
            <GridLineItem>
                <FontBody1 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation(returnMethod.name, "en")}</FontBody1>
            </GridLineItem>,

            <GridLineItem>
                <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>Display Name</FontBody3>
                <Translation Font={FontBody3} color={FONT_COLOR.PRIMARY2} translationKey={returnMethod.displayName}/>
            </GridLineItem>,

            <GridLineItem>  
                <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>Connection</FontBody3>
                <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{returnMethod.aggregatorName ?? "--"}</FontBody3>   
            </GridLineItem>,

            <GridLineIndicators>
            {hasMissingTranslations(undefined, returnMethod.getTranslationKeys()) &&
                <Tooltip
                    content={
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            There are untranslated items. Please edit <br />
                            the return method for more information.
                        </FontBody2>
                    }
                    variant={TOOLTIP_VARIANTS.ERROR}
                >
                    <Icon Component={IconTranslationIndicator} />
                </Tooltip>
            }
            </GridLineIndicators>,
            <GridLineButtons>
                <ButtonIcon Component={IconDelete} onClick={deleteCallback} />
                <ButtonIcon Component={IconEdit} onClick={onReturnMethodClicked} />
            </GridLineButtons>,
        ]}
    />
});

export default ReturnMethodLine;